// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bottom Nav Component */
bottom-nav {
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 30;
}

.bottom-nav-container {
  display: flex;
  align-items: stretch;
  padding: 0.5rem 0;
  padding-bottom: calc(0.5rem + env(safe-area-inset-bottom, 0));
  background-color: var(--bg-card);
  border-top: 1px solid var(--border-subtle);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.dark .bottom-nav-container {
  border-top-color: var(--border-subtle);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
}

.bottom-nav-btn {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.125rem;
  padding: 0.5rem;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: var(--transition-normal);
  color: var(--text-muted);
  font-family: inherit;
}

.bottom-nav-btn:hover,
.bottom-nav-btn.active {
  color: var(--text-primary);
}

.bottom-nav-btn .label {
  font-size: 0.625rem;
  font-weight: 500;
}

/* Add Button in Bottom Nav */
.bottom-nav-add-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  border: none;
  background: transparent;
  cursor: pointer;
}

.bottom-nav-add-btn-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: var(--radius-full);
  background-color: var(--text-muted);
  color: white;
  box-shadow: var(--shadow-md);
  transition: var(--transition-normal);
}

.dark .bottom-nav-add-btn-inner {
  background-color: var(--text-muted);
  color: var(--bg-main);
}

.bottom-nav-add-btn:hover .bottom-nav-add-btn-inner {
  transform: scale(1.05);
  box-shadow: var(--shadow-lg);
}

.bottom-nav-add-btn:active .bottom-nav-add-btn-inner {
  transform: scale(0.95);
}

.bottom-nav-add-btn-inner .material-symbols-outlined {
  font-size: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/bottom-nav.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,6DAA6D;EAC7D,gCAAgC;EAChC,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,mCAAmC;EACnC,YAAY;EACZ,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* Bottom Nav Component */\nbottom-nav {\n  display: block;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 30;\n}\n\n.bottom-nav-container {\n  display: flex;\n  align-items: stretch;\n  padding: 0.5rem 0;\n  padding-bottom: calc(0.5rem + env(safe-area-inset-bottom, 0));\n  background-color: var(--bg-card);\n  border-top: 1px solid var(--border-subtle);\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.dark .bottom-nav-container {\n  border-top-color: var(--border-subtle);\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);\n}\n\n.bottom-nav-btn {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.125rem;\n  padding: 0.5rem;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  transition: var(--transition-normal);\n  color: var(--text-muted);\n  font-family: inherit;\n}\n\n.bottom-nav-btn:hover,\n.bottom-nav-btn.active {\n  color: var(--text-primary);\n}\n\n.bottom-nav-btn .label {\n  font-size: 0.625rem;\n  font-weight: 500;\n}\n\n/* Add Button in Bottom Nav */\n.bottom-nav-add-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.25rem;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n.bottom-nav-add-btn-inner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.75rem;\n  height: 2.75rem;\n  border-radius: var(--radius-full);\n  background-color: var(--text-muted);\n  color: white;\n  box-shadow: var(--shadow-md);\n  transition: var(--transition-normal);\n}\n\n.dark .bottom-nav-add-btn-inner {\n  background-color: var(--text-muted);\n  color: var(--bg-main);\n}\n\n.bottom-nav-add-btn:hover .bottom-nav-add-btn-inner {\n  transform: scale(1.05);\n  box-shadow: var(--shadow-lg);\n}\n\n.bottom-nav-add-btn:active .bottom-nav-add-btn-inner {\n  transform: scale(0.95);\n}\n\n.bottom-nav-add-btn-inner .material-symbols-outlined {\n  font-size: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
